import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Fragment, useMemo, useState } from 'react';
import classNames from 'classnames/bind';
import { useMediaQuery } from "../hooks";
import HeaderPopup from '../HeaderPopup';
import MenuLinks from '../MenuLinks';
import Popover from '../Popover';
import { defaultLanguages, langs } from './constants';
import styles from './LanguageSelect.css';
var cx = classNames.bind(styles);

var getSelected = function getSelected(lang) {
  var selected = langs.find(function (item) {
    return item.locale === lang;
  });

  if (selected) {
    return selected;
  }

  return langs[0];
};

export var LanguageSelect = function LanguageSelect(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$languages = _ref.languages,
      languages = _ref$languages === void 0 ? defaultLanguages : _ref$languages,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? defaultLanguages[1] : _ref$language,
      languageProps = _ref.languageProps,
      popupProps = _ref.popupProps,
      togglerProps = _ref.togglerProps,
      onChange = _ref.onChange;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;

  var _getSelected = getSelected(language),
      flag = _getSelected.flag,
      choose = _getSelected.choose;

  var links = useMemo(function () {
    return langs.filter(function (_ref2) {
      var locale = _ref2.locale;
      return languages.includes(locale);
    }).map(function (item) {
      return _objectSpread(_objectSpread({}, languageProps), {}, {
        key: item.locale,
        children: function children() {
          return /*#__PURE__*/React.createElement(Fragment, null, item.flag, item.title);
        },
        onClick: function onClick() {
          onChange(item.locale);
          setIsOpen(false);
        }
      });
    });
  }, [languageProps, languages, onChange]);
  var toggler = /*#__PURE__*/React.createElement("div", {
    className: cx('root')
  }, /*#__PURE__*/React.createElement("div", _extends({}, togglerProps, {
    className: cx('button', {
      button_alone: links.length === 1
    })
  }), flag));
  var onToggle = links.length > 1 ? setIsOpen : undefined;
  return links.length > 1 ? /*#__PURE__*/React.createElement(Popover, {
    align: align,
    toggler: toggler,
    isOpen: isOpen,
    onToggle: onToggle,
    gap: 24
  }, /*#__PURE__*/React.createElement(HeaderPopup, _extends({
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, isMobile ? {
    size: 'small'
  } : {
    title: choose
  }), /*#__PURE__*/React.createElement("div", _extends({}, popupProps, {
    className: cx('popup')
  }), /*#__PURE__*/React.createElement(MenuLinks, {
    links: links
  })))) : toggler;
};